import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { baseBody, eventDateIcon, eventDate, eventDateRow } from "../SuggestionBody.styles";

export const container = baseBody;
export const row = eventDateRow;
export const icon = eventDateIcon;
const text = eventDate;

export const infoContainer: CSSProperties = {
  paddingTop: 6,
  paddingBottom: 6,
};

export const avatar: CSSProperties = {
  marginTop: 10,
  marginRight: 5,
};

export const textPrimary: CSSProperties = {
  ...text,
  color: colors.green.darker,
};

export const textAutopilot: CSSProperties = {
  ...textPrimary,
  fontWeight: 600,
  textTransform: "uppercase",
};

export const iconPrimary = {
  ...icon,
  htmlColor: colors.green.darker,
};

export const textRevised: CSSProperties = {
  ...text,
  textDecoration: `line-through`,
  color: greys.blueGrey,
};

export const textRoom: CSSProperties = {
  ...text,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const textRoomPrimary: CSSProperties = {
  ...textRoom,
  color: colors.green.darker,
};
